/**
 * Arena empty state mascot — Monkey (happy), static (no animation).
 */

import React, { useMemo } from 'react';
import { View } from 'react-native';
import { Image } from 'expo-image';
import { ARENA_EMPTY_MONKEY_SOURCE } from '../../../constants/assets';
import { WEB_IMAGE_ALT_DECORATIVE } from '../../../src/shared/helpers/imageWebAlt.helper';
import { useTheme } from '../../../src/theme/useTheme';
import { getArenaEmptyStateMonkeyStyles } from './ArenaEmptyStateMonkey.styles';

export const ArenaEmptyStateMonkey: React.FC = () => {
  const theme = useTheme();
  const styles = useMemo(() => getArenaEmptyStateMonkeyStyles(theme), [theme]);

  return (
    <View style={styles.halo}>
      <View style={styles.mascotAnimatedWrap}>
        <Image
          source={ARENA_EMPTY_MONKEY_SOURCE}
          style={styles.mascotImage}
          contentFit="contain"
          alt={WEB_IMAGE_ALT_DECORATIVE}
        />
      </View>
    </View>
  );
};
